<template>
  <div>
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div
        class="mx-2 w-full max-w-lg max-h-full bg-white shadow-lg rounded-lg p-5 overflow-auto"
      >
        <div class="w-full text-right sticky top-0 right-0">
          <button
            aria-label="close"
            class="text-xl text-gray-500"
            @click.prevent="close"
          >
            ×
          </button>
        </div>
        <div class="flex flex-wrap">
          <div
            v-if="!newExternalLink"
            class="w-full text-left px-3 pb-3 text-teal-700 text-2xl font-bold"
          >
            Actualización de subcategoría
          </div>
          <div
            v-if="newExternalLink"
            class="w-full text-left px-3 pb-3 text-teal-700 text-2xl font-bold"
          >
            Nueva subcategoría
          </div>

          <div class="flex flex-col w-full pl-4">
            <form class="w-full max-w-lg" id="externalLinkForm" @submit.prevent>
              <div class="flex flex-wrap -mx-3">
                <div class="w-full px-3 mb-6">
                  <label
                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                    for="name"
                    >Nombre *</label
                  >
                  <input
                    :class="{ 'border-red-500': errors.name }"
                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    id="name"
                    type="text"
                    name="name"
                    v-model="externalLink.name"
                  />
                  <p v-if="errors.name" class="text-red-500 text-xs italic">
                    Ingrese el nombre de la subcategoria.
                  </p>
                </div>
                <div class="w-full px-3 mb-6">
                  <label
                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                    for="categoria"
                    >Categoría *</label
                  >
                  <div class="relative">
                  <select
                    id="categoria"
                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    v-model="selectedCategory"
                    name="categoria"
                  >
                    <option value="" disabled selected >
                      Seleccione una categoría
                    </option>
                    <template v-for="categoria in this.arrayMainCategories">
                      <option
                        :value="categoria"
                        :key="categoria.id"
                      >
                        {{ categoria.nombre }}
                      </option>
                    </template>
                  </select>
                  <div
                    class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                  >
                    <svg
                      class="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path
                        d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                      />
                    </svg>
                  </div>
                  </div>
                  <p v-if="errors.categoria" class="text-red-500 text-xs italic">
                    Ingrese la categoría principal.
                  </p>
                </div>
                <div class="w-full px-3 mb-6">
                  <label
                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                    for="tipo"
                    >Tipo *</label
                  >
                  <div class="relative">
                  <select
                    id="tipo"
                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    v-model="selectedType"
                    name="tipo"
                  >
                    <option value="" disabled selected>
                      Seleccione un tipo
                    </option>
                    <template v-for="tipo in arrayTypes">
                      <option
                        :value="tipo"
                        :key="tipo.id"
                      >
                        {{ tipo.nombre }}
                      </option>
                    </template>
                  </select>
                  <div
                    class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                  >
                    <svg
                      class="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path
                        d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                      />
                    </svg>
                  </div>
                  </div>
                  <p v-if="errors.tipo" class="text-red-500 text-xs italic">
                    Ingrese un tipo.
                  </p>
                </div>

                  <p
                    v-if="errors.icon_category"
                    class="text-red-500 text-xs italic"
                  >Debe seleccionar un ícono.</p>
                <div class="w-full px-3 mb-6">
                  <span
                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  >Seleccione un ícono</span>
                  <div class="divicons flex flex-wrap items-center justify-center">
                    <template v-for="(icon, index) in icons">
                      <img
                        :class="{'bg-teal-500': selectedIcon === icon.name}"
                        class="w-16 h-16 p-2 cursor-pointer"
                        :src="srcUrl + icon.url"
                        :key="index"
                        @click="selectIcon(icon)"
                      />
                    </template>
                  </div>
                </div>                   


              </div>

              <div class="flex w-full justify-end">
                <button
                  class="bg-blue-500 hover:bg-blue-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="saveSubcategory()"
                >
                  Guardar
                </button>
                <button
                  class="ml-2 bg-red-500 hover:bg-red-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="close()"
                >
                  Cerrar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <alert-dialog :showing="showingSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Subcategoría guardada exitosamente</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccess = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>
    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">{{ errors.codeError }}</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-red-400"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>
  </div>
</template>

<script>
import { backend_url } from "../config/url.config.ts";
import EventBus from "../event-bus";
import AlertDialog from "./AlertDialog";

export default {
  name: "external-link-modal",
  data() {
    return {
      aux_externalLink: null,
      externalLink: {
        name: null,
        // description: null,
        id: null,
        selectedCategory: {},
        selectedType: {},
        icon: null    
      },
      arrayMainCategories: [],
      arrayTypes: [],
      selectedCategory: "",
      selectedType: "",
      errors: {
        name: false,
        categoria: false,
        tipo: false,
        codeError: "Ha ocurrido un error",
        icon_category: false,
      },
      showingSuccess: false,
      showingError: false,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        },
      },
       icons: [],
       selectedIcon: null,
       srcUrl: backend_url,
       category_url: null      

    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean,
    },
    newExternalLink: {
      required: true,
      type: Boolean,
    },
  },
  watch: {
    showing(value) {
      if (value) {
        this.fetchMainCategories();
        this.fetchTypes();
        return document.querySelector("body").classList.add("overflow-hidden");
      }
      document.querySelector("body").classList.remove("overflow-hidden");
    },

    selectedCategory: function (){

    },

    selectedType: function (){

    }

  },
  mounted() {
    EventBus.$on("editModal", this.setData);
    EventBus.$on("newModal", this.newData);
    this.fetchCategoriesIcons();
    this.category_url = this.srcUrl + "/" + this.externalLink.url_image;
  },
  components: {
    AlertDialog,
  },
  methods: {
    reset: function() {
      this.externalLink = {
        name: null,
        //categoria: null,
        //tipo: null,
        id: null,
        selectedCategory: {},
        selectedType: {}
      };
      this.errors = {
        nombre: false,
        categoria: null,
        tipo: null,
        codeError: "Ha ocurrido un error",
      };
    },

    close() {
      this.reset();
      this.$emit("close");
    },

    setData: function(category) {
      console.log("setData",category)

      this.externalLink.name = category.nombre
      this.externalLink.id = category.id

      this.externalLink.selectedCategory["id"] = category.id_maincategory
      this.externalLink.selectedCategory["nombre"] = category.cat_principal_nombre
      this.externalLink.selectedCategory["icon"] = category.icon
      this.externalLink.selectedCategory["url_image"] = category.url_image

      this.externalLink.selectedType["id"] = category.tipo_id
      this.externalLink.selectedType["nombre"] = category.tipo_nombre    
      this.externalLink.icon = category.icon;
      
      this.selectedCategory = this.externalLink.selectedCategory
      this.selectedType = this.externalLink.selectedType

      this.selectedIcon = category.icon;
    //  console.log(this.selectedCategory)
      //this.externalLink = Object.assign({}, category);
      this.aux_externalLink = Object.assign({}, this.externalLink);
      
    },
    newData: function() {
      //console.log("new data")
      this.selectedCategory = ""
      this.selectedType = ""
    },

    saveSubcategory() {
      const form = document.getElementById("externalLinkForm");
      const signInData = new FormData(form);

      if (this.newExternalLink) {
          const validForm = this.checkExternalLinkForm(signInData);

          if (validForm) {


            signInData.set("icon", this.selectedIcon);

            let data = {
              id_maincategory: this.selectedCategory.id,
              nombre: this.externalLink.name,
              id_type: this.selectedType.id,
              icon: this.externalLink.icon
            }            

            this.axios
              .post(backend_url + "/api/ppd/subcategorias/newSubcategory", data, this.config)
              .then((response) => {
                return this.axios.post(
                  backend_url + "/api/binnacles/monitor/save/",
                  {
                    module: "Configuración",
                    action: "Creación de una subcategoría",
                    observation: this.externalLink.name,
                    email: localStorage.getItem("email"),
                  },
                  this.config
                );
              })
              .then(() => {
                this.showingSuccess = true;
                this.$emit("updateAllExternalLinks");
                this.reset();
                this.$emit("close");
              })
              .catch((error) => {
                console.log(error.response);
                if (
                  error.response.status == 400 ||
                  error.response.status == 401
                ) {
                  if (
                    error.response.data.name === "TokenExpiredError" ||
                    error.response.data.name === "InvalidTokenError" ||
                    error.response.data.name === "JsonWebTokenError"
                  ) {
                    this.$router.push({ path: "/login" });
                  }
                }
                if (error.response.status == 409) {
                  this.errors.codeError =
                    "Ya hay otra subcategoría con ese nombre. Pruebe con otro nombre";
                }
                this.showingError = true;
              });
          }
      } else {
          const validForm = this.checkFormUpdateExternalLink(signInData);
          if (validForm) {
            let data = {
              id_maincategory: this.selectedCategory.id,
              nombre: this.externalLink.name,
              id_type: this.selectedType.id,
              icon: this.selectedIcon
            }

            this.axios
              .put(
                backend_url + "/api/ppd/subcategorias/updateSubcategory/" + this.externalLink.id,
                data,
                this.config
              )
              .then((response) => {
                let observation = "";
                if (this.externalLink.name != this.aux_externalLink.name) {
                  observation = `${this.aux_externalLink.name} / ${this.externalLink.name}`;
                } else {
                  observation = `${this.externalLink.name}`;
                }

                return this.axios.post(
                  backend_url + "/api/binnacles/monitor/save/",
                  {
                    module: "Configuración",
                    action: "Edición de una subcategoría",
                    observation: observation,
                    email: localStorage.getItem("email"),
                  },
                  this.config
                );
              })
              .then(() => {
                this.showingSuccess = true;
                this.$emit("updateExternalLinkModal");
                this.reset();
                this.$emit("close");
              })
              .catch((error) => {
                if (
                  error.response.status == 400 ||
                  error.response.status == 401
                ) {
                  if (
                    error.response.data.name === "TokenExpiredError" ||
                    error.response.data.name === "InvalidTokenError" ||
                    error.response.data.name === "JsonWebTokenError"
                  ) {
                    this.$router.push({ path: "/login" });
                  }
                }
                this.showingError = true;
              });
          }
      }
    },

    fetchMainCategories() {
      this.axios
        .get(backend_url + "/api/ppd/catprinc/getMainCategories", this.config)
        .then((response) => {
          //console.log(response)
          this.arrayMainCategories = response.data.categorias;
          // console.log("ARRAY DE MAIN CATEGORIES");
          // console.log(this.arrayMainCategories)
          // console.log("EXTERNAL LINK");
          // console.log(this.externalLink);
          this.arrayMainCategories.forEach(mainCat => {
            if(mainCat.id == this.externalLink.selectedCategory.id) {
              this.selectedCategory = mainCat
            }
          })
        });
    },

    fetchTypes() {
      this.axios
        .get(backend_url + "/api/ppd/tipolevantamiento/getTypes", this.config)
        .then((response) => {
          this.arrayTypes = response.data.tipos;
        });
    },

    fetchCategoriesIcons() {
      this.axios
        .get(backend_url + "/api/ppd/catprinc/getIcons", this.config)
        .then(response => {
    //      console.log(response)
          this.icons = response.data.icons;
        })
        .catch(error => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    selectIcon(icon) {
      this.selectedIcon = icon.name;
  //    console.log(this.selectedIcon)
      this.externalLink.icon = this.selectedIcon
    },    

    checkExternalLinkForm: function(signInData) {
      if (signInData.get("name") === "") {
        this.errors.name = true;
      } else {
        this.errors.name = false;
      }
      console.log(signInData.get("categoria"))
      if (signInData.get("categoria") === "" || signInData.get("categoria") === null) {
        this.errors.categoria = true;
      } else {
        this.errors.categoria = false;
      }

      console.log(signInData.get("tipo") )
      if (signInData.get("tipo") === "" || signInData.get("tipo") === null) {
        this.errors.tipo = true;
      } else {
        this.errors.tipo = false;
      }

      console.log(this.selectedIcon)
      if(this.selectedIcon === null){
   //     console.log("errors.icon_category")
        this.errors.icon_category = true;
      }
      else{
        this.errors.icon_category = false;
      }      

      if (this.errors.name || this.errors.categoria || this.errors.tipo || this.errors.icon_category) {
        return false;
      }

      return true;
    },

    checkFormUpdateExternalLink: function(signInData) {
      if (signInData.get("nombre") === "") {
        this.errors.name = true;
      } else {
        this.errors.name = false;
      }

      if (signInData.get("categoria") === "") {
        this.errors.categoria = true;
      } else {
        this.errors.categoria = false;
      }

      if (signInData.get("tipo") === "") {
        this.errors.tipo = true;
      } else {
        this.errors.tipo = false;
      }

      if (this.errors.nombre || this.errors.categoria || this.errors.tipo) {
        return false;
      }

      return true;
    },
  },
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
.text-teal-700 {
  color: #6e5b25;
}

.divicons{
  /* background-color: aqua; */
  height: 200px;
  overflow-y: scroll;
  
}

</style>
